import {
  MdOutlinedFlag,
  MdOutlineInventory,
  MdStorefront,
  MdTune,
  MdOutlineHttps,
  MdOutlineKeyboardTab,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";

import Logo from "../../assets/images/white-logo.svg";
import LogoMin from "../../assets/images/logoMin.jpg";
import { useAuth } from "../../hooks/auth";
import { permissions } from "../../shared/Permissions";
import PackageJson from "../../../package.json";

import { useResponsive } from "../../hooks/useResponsive";
import * as S from "./styles";
import { useTranslation } from "react-i18next";

export function SideBarMenu() {
  const navigate = useNavigate();
  const { user, signOut, shopSelected, hasPermission } = useAuth();
  const { changeIsResponsive, isResponsive } = useResponsive();

  const { t } = useTranslation();

  const handleNavigateToDashboard = () => {
    navigate("/");
  };

  const handleNavigateToPinSignIn = () => {
    signOut(true);
  };

  return (
    <S.MenuContainer responsiveLayout={isResponsive}>
      <S.MenuContent className={isResponsive ? "responsive_layout" : ""}>
        {isResponsive ? (
          <>
            <img
              src={isResponsive ? LogoMin : Logo}
              alt="logo"
              onClick={handleNavigateToDashboard}
              style={{ height: 48, width: 48 }}
            />
          </>
        ) : (
          <>
            <img src={Logo} alt="logo" onClick={handleNavigateToDashboard} />
          </>
        )}

        <S.CentralStoreButton
          className={isResponsive ? "store_button_responsive" : ""}
          to="/"
          title={
            user &&
            (shopSelected.name.length > 23
              ? `${shopSelected.name.slice(0, 16)}...`
              : shopSelected.name)
          }
        >
          <S.LocationIcon
            className={isResponsive ? "location_icon_responsive" : ""}
          />
          {!isResponsive && (
            <span>
              {user &&
                (shopSelected.name.length > 23
                  ? `${shopSelected.name.slice(0, 16)}...`
                  : shopSelected.name)}
            </span>
          )}
        </S.CentralStoreButton>

        <S.MenuOptionsContainer>
          <S.MenuButton
            className={isResponsive ? "menu_button_responsive" : ""}
            to="/"
            title={t("stores")}
          >
            <MdStorefront size={"1rem"} />
            {!isResponsive && <span>{t("stores")}</span>}
          </S.MenuButton>

          {hasPermission(permissions.menu.inventory) && (
            <S.MenuButton
              className={isResponsive ? "menu_button_responsive" : ""}
              to="/inventory"
              title={t("inventory")}
            >
              <MdOutlineInventory size={"1rem"} />
              {!isResponsive && <span>{t("inventory")}</span>}
            </S.MenuButton>
          )}

          {hasPermission(permissions.menu.report) && (
            <S.MenuButton
              className={isResponsive ? "menu_button_responsive" : ""}
              to="/report"
              title={t("report")}
            >
              <MdOutlinedFlag size={"1rem"} />
              {!isResponsive && <span>{t("report")}</span>}
            </S.MenuButton>
          )}
        </S.MenuOptionsContainer>

        {hasPermission(permissions.menu.settings) && (
          <S.MenuButton
            className={isResponsive ? "menu_button_responsive" : ""}
            to="/settings"
            title={t("settings")}
          >
            <MdTune size={"1rem"} />
            {!isResponsive && <span>{t("settings")}</span>}
          </S.MenuButton>
        )}

        <S.LockContainer
          className={isResponsive ? "button_responsive" : ""}
          onClick={handleNavigateToPinSignIn}
          title={t("pinLogin")}
        >
          <MdOutlineHttps size={"1rem"} style={{ flexShrink: 0 }} />
          {!isResponsive && <p>{t("pinLogin")}</p>}
        </S.LockContainer>

        <S.HideMenu
          className={isResponsive ? "button_responsive" : ""}
          onClick={() => {
            changeIsResponsive();
          }}
        >
          <MdOutlineKeyboardTab
            size={"1rem"}
            style={{
              transform: isResponsive ? "rotate(0deg)" : "rotate(180deg)",
            }}
          />
          {!isResponsive && <p>{t("hideMenu")}</p>}
        </S.HideMenu>
        <S.VersionContainer responsiveLayout={isResponsive}>
          <p>
            {isResponsive
              ? `V${PackageJson.version}`
              : `${t("version")} ${PackageJson.version}`}
          </p>
        </S.VersionContainer>
      </S.MenuContent>
    </S.MenuContainer>
  );
}
